import React from 'react';
export const Oidc = React.createContext({
    signIn: async () => { },
    signInCallback: async () => { },
    signInSilentCallback: async () => { },
    signOut: async () => { },
});
//# sourceMappingURL=OidcContext.js.map